import { EntityConfig } from 'angular-odata';

//#region ODataApi Imports
import { ProduktTyp } from './produkttyp.entity';
//#endregion

export const ProduktTypConfig = {
  name: "ProduktTyp",
  annotations: [],
  fields: {
    name: {type: 'Edm.String'},
    description: {type: 'Edm.String'},
    value: {type: 'Edm.String'},
    sortValue: {type: 'Edm.Int32'},
    statusId: {type: 'Edm.Int32'},
    statusTypeId: {type: 'Edm.Int32'},
    statusAt: {type: 'Edm.DateTimeOffset'},
    statusBy: {type: 'Edm.String'},
    createdBy: {type: 'Edm.String'},
    id: {type: 'Edm.Int32', key: true, ref: 'id', nullable: false},
    articles: {type: 'entities.Artikel', collection: true, navigation: true},
    attributes: {type: 'entities.produkte.ProduktTypAttribute', collection: true, navigation: true},
    produktTypGroups: {type: 'entities.produkte.ProduktTypGroup', collection: true, navigation: true},
    status: {type: 'entities.settings.Status', navigation: true, field: 'statusId', ref: 'id'},
    statusType: {type: 'entities.settings.StatusType', navigation: true, field: 'statusTypeId', ref: 'id'}
  }
} as EntityConfig<ProduktTyp>;